import { AnyAction } from 'redux';
import * as actionTypes from '../actions/slideshow';

const initialState = {
  current: {
    loaded: false,
    error: undefined,
    data: undefined,
  },
  list: {
    loaded: false,
    error: undefined,
    data: [],
  },
};

export default (state = initialState, action: AnyAction) => {
  switch (action.type) {
    /*  GET SLIDESHOW PART  */
    case `${actionTypes.SLIDESHOW_GET}:reset`: {
      return {
        ...state,
        current: {
          ...initialState.current,
        },
      };
    }
    case `${actionTypes.SLIDESHOW_GET}:loading`: {
      return {
        ...state,
        current: {
          ...state.current,
          loaded: false,
          error: undefined,
        },
      };
    }
    case `${actionTypes.SLIDESHOW_GET}:error`: {
      return {
        ...state,
        current: {
          ...state.current,
          loaded: true,
          error: action.payload,
        },
      };
    }
    case `${actionTypes.SLIDESHOW_GET}:success`: {
      return {
        ...state,
        current: {
          ...state.current,
          data: action.payload,
          loaded: true,
          error: undefined,
        },
      };
    }
    default:
      return state;
  }
};
